// extracted by mini-css-extract-plugin
module.exports = {"loader":"IconSocialMediaInstagram_loader__2Mdy4","root":"IconSocialMediaInstagram_root__36ab8"};